import styled from 'styled-components'

export const SmallTitle = styled.small`
  font-weight: 500;
  display: block;
`
